import React, { useRef,useEffect } from "react";
import confetti from "canvas-confetti";

const CustomCanvasConfetti = ({AnimType}) => {
  const canvasRef = useRef(null);
useEffect(()=>{
    // confetti({
    //     particleCount: 200,
    //     spread: 100,
    //     origin: { y: 0.6 },
    //   });

    const duration = 2 * 1000; // 2 seconds
  const end = Date.now() + duration;

  const frame = () => {
    if(AnimType=="firework"){
        confetti({
      particleCount: 10,
      spread: 30,
      origin: {
        x: Math.random(), // Random horizontal position
        y: Math.random() * 0.5, // Random vertical position (top half)
      },
    });
    confetti({
        particleCount: 10,
        spread: 50,
        origin: {
            x:  Math.random() *0.3, // Random horizontal position
          y: Math.random() *0.3, // Random vertical position (top half)
        },
      });

      confetti({
        particleCount: 10,
        spread: 50,
        origin: {
            x:  Math.random() *0.8, // Random horizontal position
          y: Math.random() *0.9, // Random vertical position (top half)
        },
      });

      confetti({
        particleCount: 10,
        spread: 50,
        origin: {
            x:  Math.random() *0.5, // Random horizontal position
          y: Math.random() *0.1, // Random vertical position (top half)
        },
      });

    }
      if(AnimType=="cannon"){
      confetti({
        angle: 60, // Direction of the blast
        spread: 105, // Spread angle
        particleCount: 10,
        origin: { x: 0, y: 0.9 }, // Starts from bottom-left
      });
    
      confetti({
        angle: 120,
        spread: 105,
        particleCount: 10,
        origin: { x: 1, y: 0.9 }, // Starts from bottom-right
      });
  }
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    } }

  frame();
// Fountain
//   confetti({
//     particleCount: 100,
//     startVelocity: 30, // Speed of particles
//     spread: 120,
//     gravity: 0.5,
//     origin: { x: 0.5, y: 1 }, // Starts from the bottom center
//   });
},[])
  

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
     
    </div>
  );
};

export default CustomCanvasConfetti;
